<template>
  <div class="result">
    <div class="result_title">
      2. ¡Felicitaciones!
    </div>
    <div class="result_icon">
      <span class="material-icons">
        check_circle
      </span>
    </div>
    <div class="result_description">
      Ya puedes matricularte
    </div>
    <div class="result_level" v-if="scoreResult">
      {{ scoreResult.course_name }}
    </div>
    <div class="result_footer">
      <v-btn color="primary" class="uppercase" to="/principal">
        quiero matricularme
      </v-btn>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  methods: {
    ...mapMutations(["setScoreResult"])
  },
  computed: {
    ...mapGetters({
      language: "language",
      program: "program",
      recognition: "recognition",
      postulation: "postulation",
      postulationIsNull: "postulationIsNull",
      scoreResult: "scoreResult"
    })
  },
  mounted() {
    console.log("TestResult - Program", this.program);
    console.log("TestResult - recognition", this.recognition);
  }
};
</script>
